const pageNameKey = "otaConfigurationStart";

export const otaConfigurationStartEn = {
  [pageNameKey]: {
    noConfigurationAvailableText: "No configuration available",
    uploadYourConfigurationText: "Upload your configuration",
    uploadConfigurationText: "Upload Configuration",
  },
};

export const otaConfigurationStartPtBr = {
  [pageNameKey]: {
    noConfigurationAvailableText: "Nenhuma configuração disponível",
    uploadYourConfigurationText: "Envie sua configuração",
    uploadConfigurationText: "Configuração de upload",
  },
};

export const otaConfigurationStartDe = {
  [pageNameKey]: {
    noConfigurationAvailableText: "Keine Konfiguration verfügbar",
    uploadYourConfigurationText: "Laden Sie Ihre Konfiguration hoch",
    uploadConfigurationText: "Konfiguration hochladen",
  },
};

export const otaConfigurationStartZhHans = {
  [pageNameKey]: {
    noConfigurationAvailableText: "没有可用的配置",
    uploadYourConfigurationText: "上传您的配置",
    uploadConfigurationText: "上传配置",
  },
};

export const otaConfigurationStartIt = {
  [pageNameKey]: {
    noConfigurationAvailableText: "Nessuna configurazione disponibile",
    uploadYourConfigurationText: "Carica la tua configurazione",
    uploadConfigurationText: "Caricamento della configurazione",
  },
};

export const otaConfigurationStartEs = {
  [pageNameKey]: {
    noConfigurationAvailableText: "No hay configuración disponible",
    uploadYourConfigurationText: "Sube tu configuración",
    uploadConfigurationText: "Subir configuración",
  },
};

export const otaConfigurationStartNl = {
  [pageNameKey]: {
    noConfigurationAvailableText: "Geen configuratie beschikbaar",
    uploadConfigurationText: "Configuratie uploaden",
    uploadYourConfigurationText: "Upload uw configuratie",
  },
};

export const otaConfigurationStartTr = {
  [pageNameKey]: {
    noConfigurationAvailableText: "Yapılandırma mevcut değil",
    uploadConfigurationText: "Yapılandırmayı Yükle",
    uploadYourConfigurationText: "Yapılandırmanızı yükleyin",
  },
};
